import { cloneDeep } from 'lodash';
import questionTypes from '../questionTypes';

import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';
import backButtonConfig from './backButton';
import generateClientUuid from '../../utils/generateClientUuid';
import buttonBlockToFormInitialValues from './buttonBlockToFormInitialValues';

export default {
  type: questionTypes.nextButton,
  pickBlockPropsToInitialValues: buttonBlockToFormInitialValues,
  getDefaultProps: () => ({
    backButton: {
      ...cloneDeep(backButtonConfig.getDefaultProps()),
      clientUuid: generateClientUuid(),
    },
    label: 'Next',
    alignment: 'right',
    ...getCommonBlockProps(),
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isUniqueField: sectionName => sectionName === 'landing',
    isRequiredField: sectionName => sectionName === 'landing',
    isTextRequired: () => false,
  },
};
